export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ16.7df42e45.mp3";